import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatDialogClose } from '@angular/material/dialog';

@Component({
    selector: 'da-add-customer-dialog',
    templateUrl: './add-customer-dialog.component.html',
    styleUrl: './add-customer-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormField, MatLabel, MatInput, MatButton, MatDialogClose]
})
export class AddCustomerDialogComponent {

}
